import { useEffect, useState } from "react";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchMonthSingleForm } from "src/components/common/form/search/SearchMonthSingleForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { formatDateMonth, formatDateYear4 } from "src/utils/string/stringUtil";
import { useTQC2100_R01Store } from "./Store_TQC2100_R01";

/** 사업장과 점검연월 검색조건을 입력하는 영역 */
export const SearchSection_TQC2100_R01 = () => {
	const { compCdList } = useCommonCodeStore();
	const { TQC2100_R01Filter, setTQC2100_R01Filter } = useTQC2100_R01Store();
	const [visible, setVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

	useEffect(() => {
		// 사업장 공통코드가 준비되면 첫 번째 사업장을 기본값으로 지정한다.
		if (compCdList.length > 0 && !TQC2100_R01Filter.compCd) {
			setTQC2100_R01Filter({ compCd: compCdList[0].compCd });
		}
	}, [compCdList, TQC2100_R01Filter.compCd, setTQC2100_R01Filter]);

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="사업장"
				value={TQC2100_R01Filter.compCd}
				optionList={compCdList}
				onChangeItem={(item) =>
					setTQC2100_R01Filter({ compCd: item?.compCd || "" })
				}
				initLabelLess={true}
			/>
			<SearchMonthSingleForm
				label="점검연월"
				visible={visible}
				setVisible={setVisible}
				value={new Date(TQC2100_R01Filter.inspectDt)}
				editable={true}
				onChange={(date) =>
					setTQC2100_R01Filter({
						inspectDt: `${formatDateYear4(date)}-${formatDateMonth(date)}`,
					})
				}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
		</SearchSectionForm>
	);
};
